import React, { Component, ErrorInfo } from 'react';
import Pill from './components/peel/Pill';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  message: string;
}

class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false, message: "" };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('ErrorBoundary caught an error: ', error, errorInfo);
        this.setState({ hasError: true, message: error.message });
    }

    handleWipe() {
        caches.keys().then(async function(names) {
            for (let name of names)
                await caches.delete(name);
        });
        window.location.replace('/')
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className='notfound'>
                    <h1>در حال آپدیت اپلیکیشن هستیم. جهت دریافت آپدیت کلیک کنید</h1>
                    {this.state.message &&
                        <>
                            <h4>ارور زیر را به پشتیبانی اطلاع دهید</h4>
                            <h4>{this.state.message}</h4>

                            <br />
                            <h3>تلگرام : 09104208995</h3>
                        </>  
                    }
                    <Pill label='آپدیت' onClick={this.handleWipe} selected style={{ marginInline: 'auto' }}/>
                </div>
            );
        }

        return this.props.children;
  }
}

export default ErrorBoundary;